import React from 'react';
import {Typography} from "@mui/material";

const HomeActivity = () => {
    return (
        <div>
            <Typography
                variant="h6"
                component="h1"
                sx={{
                    marginBottom: '1em',
                    color:'#333333'
                }}

            >Home Activity</Typography>
            {/* Your component code goes here */}
        </div>
    );
};

export default HomeActivity;
